// removed by extract-text-webpack-plugin
module.exports = {"nffs-solicitation-code-definition-tooltip":"nffs-solicitation-code-definition-tooltip"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/universalDetails/niinDetailTables/subcomponents/CustomItemCell/Cell.scss
// module id = 5244
// module chunks = 1